export const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
  }
})
